import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  success: false,
  error: false
};

const MessageAddSlice = createSlice({
  name: "MessageAdd",
  initialState,
  reducers: {
    messageAddSuccess(state) {
      state.success = true;
      state.error = false;
    },
    messageAddError(state) {
      state.error = true;
      state.success = false;
    },
  },
});

export const {
  messageAddSuccess,
  messageAddError,
} = MessageAddSlice.actions

export default MessageAddSlice.reducer;
